// Import necessary modules
import accordion from './modules/accordion.js';
import testimonialCarousel from './modules/testimonialCarousel.js';
import checkboxDropdown from "./modules/dropdownCheckbox";
import { postFilters } from "./modules/postFilters"; // Removed updateFilterState import
import loadMore from "./modules/load-more";
import formHelpers from "./modules/formHelpers";
import mobileNavTriggers from "./modules/mobileNav";
import postTaxonomy from "./modules/postTaxonomy";
import { splitHeroText } from "./modules/animationHelpers";
import checkOverflow from "./modules/tableOverflowText";
import accessibilityHelpers from "./modules/accessibilityHelpers";

jQuery(document).ready(function ($) {
    // Remove no-js class and replace with js.
    $('html').addClass('js').removeClass('no-js');

    // Initialize modules
    loadMore();
    accordion();
    postFilters();
    formHelpers();
    postTaxonomy();
    mobileNavTriggers(jQuery);
    testimonialCarousel();
    checkboxDropdown(jQuery);
    splitHeroText();
    checkOverflow();
    accessibilityHelpers();

    // Handle mobile filter toggle
    const mobileToggle = document.querySelector('.post-grid-filters-mobile-toggle');
    const filtersDiv = document.querySelector('.post-grid-filters');

    if (mobileToggle && filtersDiv) {
        mobileToggle.addEventListener('click', function() {
            filtersDiv.classList.toggle('height-show');
            mobileToggle.classList.toggle('height-show');
        });
    }
});

// window.addEventListener('pageshow', (event) => {
//     if (event.persisted || performance.navigation.type === performance.navigation.TYPE_BACK_FORWARD) {
//         restoreStateFromSessionStorage();
//     }
// });
